var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_947_115539)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_947_115539)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_947_115539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_947_115539)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_947_115539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 20.0009H0.000732422V0.000854492H20.0007V20.0009Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_947_115539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1246 15.9205L6.86345 8.98852C6.293 8.50986 5.44265 8.58412 4.96414 9.15439C4.48563 9.72466 4.56015 10.575 5.1306 11.0536L13.3917 17.9856C13.9622 18.4642 14.8125 18.39 15.2911 17.8197C15.7696 17.2494 15.695 16.3991 15.1246 15.9205Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86417 11.0259L15.1253 4.09399C15.6958 3.61533 15.7703 2.765 15.2918 2.19473C14.8133 1.62446 13.9629 1.5502 13.3925 2.02886L5.13133 8.96079C4.56088 9.43945 4.48635 10.2898 4.96487 10.86C5.44338 11.4303 6.29373 11.5046 6.86417 11.0259Z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_947_115539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_947_115539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/leftIcon.d7fb751aa29fbc6bae417f519a9ddd27.svg";
export { ForwardRef as ReactComponent };